import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { Process } from '../components/Process';
import { Clients } from '../components/Clients';
import { Team } from '../components/Team';
import { FAQ } from '../components/FAQ';
import { CTASection } from '../components/CTASection';
import { ContactForm } from '../components/ContactForm';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-slate-50" data-id="element-188">
      <Navbar data-id="element-189" />
      <Hero data-id="element-190" />
      <Services data-id="element-191" />
      <Process data-id="element-192" />
      <Clients data-id="element-193" />
      <Team data-id="element-194" />
      <FAQ data-id="element-195" />
      <CTASection data-id="element-196" />
      <ContactForm data-id="element-197" />
      <Footer data-id="element-198" />
    </div>;
}